import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from 'redux/store'

export enum CurtainType {
    ENDED = 'ENDED',
    ARMAGEDDON = 'ARMAGEDDON',
}

interface CBody {
    heading: string
    title: string
    message: string
}

export const CurtainBody: {
    [k in CurtainType]: CBody
} = {
    [CurtainType.ENDED]: {
        heading: 'the event has ended',
        title: 'Thank you for joining',
        message: '',
    },
    [CurtainType.ARMAGEDDON]: {
        heading: `We'll be back in a few`,
        title: 'Please stand by',
        message: `We're having some technical difficulties and appreciate your patience.`,
    },
}

export enum CurtainValue {
    OPEN = 'open',
    CLOSED = 'closed',
    CLOSING = 'closing',
}

export interface CurtainState {
    value: CurtainValue
    isLocked: boolean
    body: CBody
}

export const initialState: CurtainState = {
    value: CurtainValue.OPEN,
    isLocked: false,
    body: { heading: '', title: '', message: '' },
}

const curtainSlice = createSlice({
    name: 'curtain',
    initialState,
    reducers: {
        resetState: _ => initialState,
        closingTheCurtain: state => {
            state.value = CurtainValue.CLOSING
        },
        closeTheCurtain: state => {
            state.value = CurtainValue.CLOSED
        },
        openTheCurtain: state => {
            state.value = CurtainValue.OPEN
        },
        lockCurtain: state => {
            state.isLocked = true
        },
        unlockCurtain: state => {
            state.isLocked = false
        },
        setCurtainEndedState: state => {
            state.body = CurtainBody[CurtainType.ENDED]
        },
        setCurtainArmageddonState: (state, { payload: message }: PayloadAction<string | undefined>) => {
            state.body = {
                ...CurtainBody[CurtainType.ARMAGEDDON],
                message: message || CurtainBody[CurtainType.ARMAGEDDON].message,
            }
        },
    },
})

const { actions, reducer } = curtainSlice
export default reducer

export const getCurtainState = (store: RootState) => store.curtain

export const getCurtainValue = createSelector(getCurtainState, curtain => curtain.value)

export const isCurtainLocked = createSelector(getCurtainState, curtain => curtain.isLocked)

export const {
    closingTheCurtain,
    closeTheCurtain,
    openTheCurtain,
    setCurtainEndedState,
    setCurtainArmageddonState,
    resetState,
    lockCurtain,
    unlockCurtain,
} = actions
